import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CMSPath } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";


const ResReservationV2_0 = (props) => {

    const { t } = props

    let imagePath;

    const handleNext = (selectedVenueGroup) => {
        props.next(selectedVenueGroup)
    }

    React.useEffect(() => {
        if (props.resVenueData.length == 1) {
            props.next(props.resVenueData[0]);
        }
    }, [props.resVenueData])

    return (
        <>
            <section class="widgets spa-listing">
                <div class="widget-header">

                    {props.currentWidgetObj.widgetHeaderImageUrl &&
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                        </div>
                    }

                    <div class="widget-header-title">{props.currentWidgets.displayName}</div>
                </div>

                <div class="widgets">
                    <div class="row margin-bottom-2">
                        <div class="col sm-banner">

                            <div class="col col-2">
                                {props.resVenueData.map((iterator) => {

                                    imagePath = iterator.imageName ? encodeURI(`${CMSPath}${iterator.imageName}`) : "";

                                    return (
                                        <a id={iterator.widgetType} className={'tile-sm thumbnails tile-container'}
                                            onClick={() => { handleNext(iterator) }}
                                        >
                                            <div class="thumb-img">
                                                {imagePath ?
                                                    <img src={imagePath}></img> :
                                                    ""
                                                }
                                            </div>

                                            <div class="thumb-text">
                                                <p class="thumb-heading">{iterator.name}</p>
                                            </div>
                                        </a>
                                    )
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )

}

const mapStateToProps = state => {
    return {
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}

export default connect(mapStateToProps, { sendAnalytics })(withTranslation('translations')(ResReservationV2_0));